import { Slide } from 'react-awesome-reveal';
import {
  FaDownload, FaTwitterSquare, FaFacebookSquare, FaLinkedin, FaGithubSquare,
} from 'react-icons/fa';
import Profile from '../images/profile.png';
import Resume from '../files/Resume.pdf';

const About = () => (
  <Slide direction="left">
    <div className="w-screen h-screen relative z-50 pl-20 pr-36 py-20 page-layout-responsive">
      <div className="bg-slate-50 dark:bg-slate-800 w-full h-full rounded-xl p-10 overflow-y-scroll">
        <div className="mb-5">
          <p className="text-slate-500 text-lg text-center">My Intro</p>
          <h1 className="text-black dark:text-white font-bold text-center text-5xl my-4">
            About
            <span className="colored-main-left">Me</span>
          </h1>
          <div className="animated-bar" />
        </div>
        <div className="flex w-full responsive-home">
          <div className="w-2/6 px-2">
            <div className="home-profile">
              <img alt="Aime Malaika" src={Profile} className="home-profile-img" loading="lazy" />
            </div>
          </div>
          <div className="w-4/6 px-2">
            <div className="w-full about-content about-content-small">
              <h5 className="capitalize text-black dark:text-white font-bold text-left mt-5 text-2xl">
                who am
                <span className="colored-main-left">I ?</span>
              </h5>
              <h3 className="capitalize text-black dark:text-white font-bold text-left my-3 text-3xl">
                I&apos;m Aime Malaika, a visual
                <span className="colored-main-left">
                  DevOp
                </span>
                and
                <span className="colored-main-left">
                  Full Stack Web and Mobile Developer
                </span>
              </h3>
              <p className="text-slate-500 text-lg mb-2">
                I’m a passionate software engineer based in Rwanda
                with years of experience delivering top-notch development
                solutions and building software that aligns with the latest trends.
                I specialize in transforming visions and
                ideas into impactful, functional products that drive results.
              </p>
              <p className="text-slate-500 text-lg">
                With a keen eye for innovation and product evolution, I excel at prioritizing tasks,
                iterating efficiently,
                and delivering outstanding results at lightning speed.
                Let’s bring your ideas to life
                and create meaningful digital solutions together!
              </p>
              <h3 className="capitalize text-black dark:text-white font-bold text-left mt-8 mb-3 text-3xl">
                personal
                <span className="colored-main-left">
                  Informations
                </span>
              </h3>
              <div className="flex personal-info">
                <div className="w-1/2">
                  <p className="capitalize text-slate-500 text-lg py-2">
                    first name:
                    <span className="text-black dark:text-white pl-3">Aime</span>
                  </p>
                  <p className="capitalize text-slate-500 text-lg py-2">
                    last name:
                    <span className="text-black dark:text-white pl-3">Malaika</span>
                  </p>
                  <p className="capitalize text-slate-500 text-lg py-2">
                    address:
                    <span className="text-black dark:text-white pl-3">Kagugu, Kigali, Rwanda</span>
                  </p>
                  <p className="capitalize text-slate-500 text-lg py-2">
                    From:
                    <span className="text-black dark:text-white pl-3">Kigali, Rwanda</span>
                  </p>
                  <p className="capitalize text-slate-500 text-lg py-2">
                    Skype :
                    <span className="text-black dark:text-white pl-3">live:91ec82f181053673</span>
                  </p>
                </div>
                <div className="w-1/2">
                  <p className="capitalize text-slate-500 text-lg py-2">
                    Email:
                    <span className="text-black dark:text-white pl-3">
                      <a className="custom-link-color" href="mailto:malaikaime@gmail.com">malaikaime@gmail.com</a>
                    </span>
                  </p>
                  <p className="capitalize text-slate-500 text-lg py-2">
                    Phone:
                    <span className="text-black dark:text-white pl-3">
                      <a className="custom-link-color" href="tel:+250787561924">+250787561924</a>
                    </span>
                  </p>
                  <p className="capitalize text-slate-500 text-lg py-2">
                    Langages :
                    <span className="text-black dark:text-white pl-3">French, English, Swahili, Kinyarwanda</span>
                  </p>
                  <p className="capitalize text-slate-500 text-lg py-2">
                    Freelance :
                    <span className="text-black dark:text-white pl-3">Available</span>
                  </p>
                </div>
              </div>
              <a href={Resume} target="blanc" download className="button-style flex w-3/12 w-sm-1/2 justify-between my-3 small-screen-button">
                Download CV
                <FaDownload />
              </a>
              <div className="social-icons about">
                <ul className="flex items-center mt-5">
                  <li className="pr-2.5">
                    <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://twitter.com/Aime_Malaika">
                      <FaTwitterSquare />
                    </a>
                  </li>
                  <li className="px-2.5">
                    <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://www.facebook.com/aime.malaikamichaelange">
                      <FaFacebookSquare />
                    </a>
                  </li>
                  <li className="px-2.5">
                    <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://www.linkedin.com/in/aimemalaika">
                      <FaLinkedin />
                    </a>
                  </li>
                  <li className="px-2.5">
                    <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://github.com/aimemalaika">
                      <FaGithubSquare />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Slide>
);

export default About;
